import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { UserResolver } from 'app/core/resolvers/user.resolver';
import { UserListComponent } from './user-list/user-list.component';

const routes: Routes = [

  {
    path:"",
    resolve: {
      users: UserResolver
    },
    component:UserListComponent
  },

];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class UsersRoutingModule { }
